import { toast } from "react-toastify";

export const successToast = (message = "Success", timeOut = 3000) => {
    toast.success(message, {
        position: "top-center",
        autoClose: timeOut,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
};
export const errorToast = (message = "Error ", timeOut = 3000) => {
    toast.error(message, {
        position: "top-center",
        autoClose: timeOut,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
    });
};

